import toast from 'react-hot-toast'

export type ApiError = {
  message: string
  code?: string
}

// Em produção, se VITE_API_BASE_URL não for definido, usa a API Workers para evitar 405 no login.
const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ??
  (import.meta.env.PROD ? 'https://ncc-sistema-rh-api.ncc-92d.workers.dev' : '')

// Token em memória (não persistido). Assim, ao recarregar/abrir novamente, exige login.
let memoryToken: string | null = null

export function setApiToken(token: string | null) {
  memoryToken = token
}

function getToken(): string | null {
  return memoryToken
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit & { auth?: boolean; quiet?: boolean } = { auth: true }
): Promise<T> {
  const url = `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`

  const headers = new Headers(init.headers ?? {})
  headers.set('Accept', 'application/json')
  if (!headers.has('Content-Type') && init.body) headers.set('Content-Type', 'application/json')

  if (init.auth !== false) {
    const token = getToken()
    if (token) headers.set('Authorization', `Bearer ${token}`)
  }

  const res = await fetch(url, { ...init, headers })
  const isJson = (res.headers.get('content-type') ?? '').includes('application/json')
  const body = isJson ? await res.json().catch(() => null) : await res.text().catch(() => null)

  if (!res.ok) {
    const err: ApiError = body && typeof body === 'object' ? body : { message: String(body ?? res.statusText) }
    if (!init.quiet) toast.error(err.message || 'Falha na requisição')
    throw err
  }

  return body as T
}

